import React, { useState, useEffect } from 'react';
import AssignedCourses from './assignedCourses';
import LicencesHistory from './licencesHistory';
import MicroModuleListing from './microModuleListing';
import Modal from 'react-modal';
import ArchiveOrgModal from '../modal/archiveOrgModal';
import apiService from '../../../services/apiService';
import EditOrgnisation from './editOrganization';
import { useParams } from 'react-router-dom';
import Loader from '../../layouts/loader';
import dayjs from 'dayjs';

const OrganisationDetails = () => {
    const [archiveOrgModalIsOpen, setArchiveOrgModalIsOpen] = useState(false);
    const [orgDetails, setOrgDetails] = useState('');
    const [userDetail, setUserData] = useState()
    const [isEditing, setIsEditing] = useState(false);
    const [loader, setLoader] = useState(false);
    const [licenseInfo, setLicenseInfo] = useState();
    const [selectedOrgId, setselectedOrgId] = useState('')
    const { org_id } = useParams();

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const openArchiveOrgModal = () => {
        setArchiveOrgModalIsOpen(true);
    };

    const closeArchiveOrgModal = () => {
        setArchiveOrgModalIsOpen(false);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        let userDetail = sessionStorage.getItem("userDetail")
        userDetail = JSON.parse(userDetail)
        if (org_id) {
            localStorage.setItem("ORGID", org_id)
        }
        const orgId = org_id || localStorage.getItem('ORGID')
        setLoader(true);
        setselectedOrgId(orgId)
        setUserData(userDetail)
        fetchOrgDetails(orgId);
        fetchLicense(orgId);
    }, []);

    const fetchLicense = (orgid) => {
        const token = apiService.getAuthToken()
        const org_id = orgid
        apiService.getv1(`get-license-history/${org_id}`, token).then(
            (response) => {
                setLicenseInfo(response.data);
            },
            (error) => {
                console.error("Error fetching data", error);
            }
        );
    };

    const fetchOrgDetails = (orgid) => {
        const org_id = orgid
        const token = apiService.getAuthToken()
        apiService.getv1(`get-org-details/${org_id}`, token).then(
            (response) => {
                setOrgDetails(response.data);
                const obj = {
                    org_id: response?.data?.org_id,
                    org_name: response?.data?.org_name
                }
                localStorage.setItem("orgData", JSON.stringify(obj))
                setLoader(false);
            },
            (error) => {
                setLoader(false);
                console.error("Error fetching data", error);
            }
        );
    };

    return (
        <div className='page__main'>
            <div className="dashboard" style={{ minHeight: '100vh' }}>
                {isEditing && (
                    <EditOrgnisation orgData={orgDetails} onClose={() => setIsEditing(false)} />
                ) || <>
                        <h4 className='font-26 fw-bold mb-4'>Org. Dashboard</h4>
                        <div className="row">
                            <div className="col-md-8">
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center mb-4 border-bottom ">
                                            <h4 className="fw-bold font-20 mb-3">
                                                <img src="/images/org_info_icon.svg" className="small-icon me-2" width={25} />
                                                Basic Information
                                            </h4>
                                            <a onClick={handleEditClick} className="d-flex align-items-center text-decoration-none">
                                                <span className="fw-bold rounded-pill mb-2 py-1 bg-primary_custom primary_color">
                                                    Edit
                                                </span>
                                            </a>
                                            {/* <span className="d-flex align-items-center justify-content-center ps-3 link-dark text-decoration-none dropdown-toggle" id="dropdownUser4" data-bs-toggle="dropdown" aria-expanded="false">
                           <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                               <path d="M16.3337 21.668C17.0409 21.668 17.7192 21.9489 18.2193 22.449C18.7194 22.9491 19.0003 23.6274 19.0003 24.3346C19.0003 25.0419 18.7194 25.7202 18.2193 26.2203C17.7192 26.7204 17.0409 27.0013 16.3337 27.0013C15.6264 27.0013 14.9481 26.7204 14.448 26.2203C13.9479 25.7202 13.667 25.0419 13.667 24.3346C13.667 23.6274 13.9479 22.9491 14.448 22.449C14.9481 21.9489 15.6264 21.668 16.3337 21.668ZM16.3337 13.668C17.0409 13.668 17.7192 13.9489 18.2193 14.449C18.7194 14.9491 19.0003 15.6274 19.0003 16.3346C19.0003 17.0419 18.7194 17.7202 18.2193 18.2203C17.7192 18.7204 17.0409 19.0013 16.3337 19.0013C15.6264 19.0013 14.9481 18.7204 14.448 18.2203C13.9479 17.7202 13.667 17.0419 13.667 16.3346C13.667 15.6274 13.9479 14.9491 14.448 14.449C14.9481 13.9489 15.6264 13.668 16.3337 13.668ZM16.3337 5.66797C17.0409 5.66797 17.7192 5.94892 18.2193 6.44902C18.7194 6.94911 19.0003 7.62739 19.0003 8.33464C19.0003 9.04188 18.7194 9.72016 18.2193 10.2203C17.7192 10.7204 17.0409 11.0013 16.3337 11.0013C15.6264 11.0013 14.9481 10.7204 14.448 10.2203C13.9479 9.72016 13.667 9.04188 13.667 8.33464C13.667 7.62739 13.9479 6.94911 14.448 6.44902C14.9481 5.94892 15.6264 5.66797 16.3337 5.66797Z" fill="black" />
                           </svg>
                       </span>
                       <ul className="dropdown-menu text-small shadow" aria-labelledby="dropdownUser4">
                           <li>
                               <a className="dropdown-item" href="/">
                               Edit
                               </a>
                           </li>
                           <li>
                               <button className="dropdown-item">
                               Export Report
                               </button>
                           </li>
                           <li>
                               <button className="dropdown-item" onClick={openArchiveOrgModal} >
                               Archive Organisation
                               </button>
                              
                               <Modal
                                   isOpen={archiveOrgModalIsOpen}
                                   onRequestClose={closeArchiveOrgModal}
                                   contentLabel="Assign Course Modal"
                               >
                                   <ArchiveOrgModal />
                               </Modal>
                           </li>
                       </ul> */}
                                        </div>

                                        {loader ? <Loader /> : (
                                            <div className="d-flex">
                                                <div className="admin-img w-50 d-flex justify-content-center align-items-center border"
                                                    style={{ maxWidth: '250px', maxHeight: '200px', background: '#F0F0F0', borderRadius: '12px' }}>
                                                    <img src={orgDetails.org_image} className="img-fluid w-100"
                                                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                                </div>

                                                <div className="admin-info font-14 w-75 ps-4">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>Organisation Name</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.org_name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>Entity</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.entities}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>Branch</p></div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.branches}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>Organisation Size</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.org_size}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>Organisation URL</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.org_url}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>Sector / Industry</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.org_sector}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>Organisation Address</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.org_address}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>City</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.org_city}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>State</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.org_state}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <p>Pin Code</p>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <p className="fw-bold"> : {orgDetails?.org_pincode}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="card mb-4">
                                    <div className="card-body font-14">
                                        <h5 className="fw-bold mb-3 font-20 border-bottom pb-3"><img src="/images/primary_contact_icon.svg" className="small-icon me-2" width={25} />Primary Contact</h5>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <p>Name</p>
                                            </div>
                                            <div className="col-md-8">
                                                <p className="fw-bold">: {orgDetails.contact_name}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <p>Email</p>
                                            </div>
                                            <div className="col-md-8">
                                                <p className="fw-bold">: {orgDetails.contact_email}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <p>Designation</p>
                                            </div>
                                            <div className="col-md-8">
                                                <p className="fw-bold">: {orgDetails.contact_designation}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <p>Phone Number</p>
                                            </div>
                                            <div className="col-md-8">
                                                <p className="fw-bold">: {orgDetails.contact_mobile}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="card mb-2">
                                    <div className='card-body font-14'>
                                        <h6 className="fw-bold mt-2"></h6>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <p>Contract Date</p>
                                            </div>
                                            <div className="col-md-8">
                                                <p className="fw-bold" style={{lineHeight: '1.8'}}>: Start Date : {orgDetails.contract_start_date ? dayjs(orgDetails.contract_start_date).format('DD/MM/YYYY') : 'N/A'}
                                                <br /><span className="ms-2">End Date : {orgDetails.contract_start_date ? dayjs(orgDetails.contract_end_date).format('DD/MM/YYYY') : 'N/A'}</span>
                                                </p>
                                            </div>
                                        </div>
                                          <div className="row">
                                            <div className="col-md-4">
                                                <p>Organisation Plan</p>
                                            </div>
                                            <div className="col-md-8">
                                                <p className="fw-bold">: {orgDetails?.plan_name || "N/A"}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
                {orgDetails ?
                    <AssignedCourses orgData={orgDetails} /> : null
                }
                {(orgDetails?.plan_id !== 'plan_1234567892' && orgDetails?.plan_id !== 'plan_1234567896' && orgDetails?.plan_id !== 'plan_1234567890') && (
                    <MicroModuleListing></MicroModuleListing>
                )}
                <LicencesHistory licenseInfo={licenseInfo} />
            </div>
        </div>
    )
}

export default OrganisationDetails;